module.exports = "<mat-form-field (click)=\"clickOnField()\" *ngIf=\"matField\">\n  <input type=\"text\" matInput [value]=\"(locField ? locField : fieldValue) | customTranslate: notLockedValue\" />\n</mat-form-field>\n\n<input\n  (click)=\"clickOnField()\"\n  class=\"def-field\"\n  *ngIf=\"!matField\"\n  type=\"text\"\n  [value]=\"(locField ? locField : fieldValue) | customTranslate: notLockedValue\"\n/>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/custom-translation-field/custom-translation-field.component.html
// module id = ./src/app/shared/components/custom-translation-field/custom-translation-field.component.html
// module chunks = main